import React from 'react';
import { formatCurrencyIntl } from '../../lib/formatters';

interface FooterProps {
  jobSavingStatus: string;
  marketBaseSalary50th: number;
  oldMarketBaseSalary50th: number;
  currency: string;
  annualOrHourly: string;
  app: object;
  loadingBasePay: boolean;
}

const Footer: React.FC<FooterProps> = (props: FooterProps) => {
  const {
    jobSavingStatus,
    marketBaseSalary50th,
    oldMarketBaseSalary50th,
    currency,
    annualOrHourly,
    app,
    loadingBasePay
  } = props;


  if (jobSavingStatus === 'JOB_NOT_SAVING') {
    return <></>;
  }

  const intl: any = {
    useThousands: false,
    useHourly: false,
    display: 'symbol',
    currency: currency,
    preferHourlyRate: false
  };

  if (annualOrHourly.toLowerCase() === 'hourly') {
    intl.useHourly = true;
  }

  let marketBaseSalary = 'N/A';

  if (marketBaseSalary50th || marketBaseSalary50th === 0) {
    marketBaseSalary = formatCurrencyIntl(marketBaseSalary50th, intl, app);
  }

  let marketBaseSalaryMsg = 'Current base pay at 50th';
  let marketBaseSalaryStatusMsg = '';

  if (marketBaseSalary50th && oldMarketBaseSalary50th) {
    if (marketBaseSalary50th !== oldMarketBaseSalary50th) {
      marketBaseSalaryMsg = 'New Base Pay at 50th';
      marketBaseSalaryStatusMsg = 'The base pay has changed for this job';
      if (marketBaseSalary === 'N/A') {
        marketBaseSalaryStatusMsg = '';
      }
    }
  }

  return (
    <div className="add-job__footer">
      <div className="add-job__footer-content">
        <div className="add-job__footer__left-section col-sm-8">
          <div className="add-job__footer__save-status">
            <span className="add-job__footer__save-msg">{jobSavingStatus}</span>
          </div>
          <div className="add-job__footer__salary-status">
            <span className="add-job__footer__salary-update-msg">{marketBaseSalaryStatusMsg}</span>
          </div>
        </div>
        <div className="add-job__footer__right-section col-sm-4">
          <div className="add-job__footer__right-section-content">
            <div className="add-job__footer__salary-msg-container">
              <span className="add-job__footer__salary-msg">{marketBaseSalaryMsg}</span>
            </div>
            <div className="add-job__footer__salary-value-container">
              {loadingBasePay ? (
                <span className="add-job__footer-salary-value--loading">
                  <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                  Calculating…
                </span>
              ) : (
                <span className="add-job__footer__salary-value">{marketBaseSalary}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;